<div class="simple-deletion-dialog">
  <div class="dialog-header">
    <h2 mat-dialog-title>Are You Sure ?</h2>
  </div>
  
  <div mat-dialog-content class="dialog-content">
    <div class="warning-text">
      <p class="main-question">Do you want to delete the {{activityText}} along with the order?</p>
      <p class="order-info">Order: {{data.impact.orderId}}</p>
      <p class="activity-info" *ngIf="hasActivitiesToDelete">
        This will affect <strong>{{activityCount}} {{activityText}}</strong> that will become empty.
      </p>
    </div>
  </div>
  
  <div mat-dialog-actions class="dialog-actions">
    <button 
      mat-stroked-button 
      class="cancel-button"
      (click)="onCancelClick()">
      Cancel
    </button>
    
    <button 
      mat-stroked-button 
      class="no-button"
      (click)="onNoClick()"
      matTooltip="This option will delete the order only"
      matTooltipPosition="above">
      No
    </button>
    
    <button 
      mat-raised-button 
      color="primary" 
      class="yes-button"
      (click)="onYesClick()"
      matTooltip="This option will delete both the {{activityText}} and the order"
      matTooltipPosition="above">
      Yes
    </button>
  </div>
</div>

